// Daily journal prompts for each day of Ramadan
export interface JournalPrompts {
  day: number;
  moodQuestion: string;
  gratitudePrompt: string;
  reflectionPrompt: string;
  duaPrompt: string;
}

export const journalPrompts: JournalPrompts[] = [
  {
    day: 1,
    moodQuestion: "How are you feeling as Ramadan begins?",
    gratitudePrompt: "What blessing are you most grateful for as you start this sacred month?",
    reflectionPrompt: "What intention are you setting for this Ramadan?",
    duaPrompt: "What is one thing you deeply need from Allah right now?"
  },
  {
    day: 2,
    moodQuestion: "How is your heart settling into the rhythm of fasting?",
    gratitudePrompt: "What small mercy did Allah show you today?",
    reflectionPrompt: "What distraction are you willing to let go of this month?",
    duaPrompt: "What do you need Allah's help with today?"
  },
  {
    day: 3,
    moodQuestion: "How are you adjusting to the new routine?",
    gratitudePrompt: "Name three things you often overlook but are grateful for.",
    reflectionPrompt: "How did you show patience today?",
    duaPrompt: "What healing are you asking Allah for?"
  },
  {
    day: 4,
    moodQuestion: "What emotions are surfacing as you fast?",
    gratitudePrompt: "Who in your life are you thankful for and why?",
    reflectionPrompt: "What did fasting teach you about yourself today?",
    duaPrompt: "What relationship do you want Allah to mend?"
  },
  {
    day: 5,
    moodQuestion: "How is your energy and spirit today?",
    gratitudePrompt: "What comfort did Allah provide you today?",
    reflectionPrompt: "What habit are you working to change this Ramadan?",
    duaPrompt: "What fear do you want to surrender to Allah?"
  },
  {
    day: 6,
    moodQuestion: "What is your heart leaning towards today?",
    gratitudePrompt: "What moment of peace did you experience today?",
    reflectionPrompt: "How can you be gentler with yourself?",
    duaPrompt: "What burden do you need Allah to lighten?"
  },
  {
    day: 7,
    moodQuestion: "How do you feel after one week of fasting?",
    gratitudePrompt: "What growth have you noticed in yourself this week?",
    reflectionPrompt: "What lesson from this week will you carry forward?",
    duaPrompt: "What dream do you want to share with Allah?"
  },
  {
    day: 8,
    moodQuestion: "What's the state of your heart right now?",
    gratitudePrompt: "What unexpected blessing surprised you today?",
    reflectionPrompt: "How did you practice mercy towards others today?",
    duaPrompt: "What do you want Allah to forgive you for?"
  },
  {
    day: 9,
    moodQuestion: "How are you feeling spiritually?",
    gratitudePrompt: "What beauty in creation reminded you of Allah today?",
    reflectionPrompt: "What verse or hadith touched your heart recently?",
    duaPrompt: "What guidance are you seeking from Allah?"
  },
  {
    day: 10,
    moodQuestion: "How do you feel as you complete the first ten days of mercy?",
    gratitudePrompt: "What mercy of Allah have you witnessed these ten days?",
    reflectionPrompt: "How has seeking mercy shaped your actions?",
    duaPrompt: "What mercy do you still yearn for?"
  },
  {
    day: 11,
    moodQuestion: "How are you entering the days of forgiveness?",
    gratitudePrompt: "What are you thankful for that you didn't have a year ago?",
    reflectionPrompt: "Who do you need to forgive, including yourself?",
    duaPrompt: "What sin weighs on your heart that you want forgiven?"
  },
  {
    day: 12,
    moodQuestion: "How is your soul responding to increased worship?",
    gratitudePrompt: "What strength has Allah given you today?",
    reflectionPrompt: "How can you extend forgiveness to someone who hurt you?",
    duaPrompt: "What regret do you want to release to Allah?"
  },
  {
    day: 13,
    moodQuestion: "What is bringing you peace today?",
    gratitudePrompt: "What provision are you thankful for today?",
    reflectionPrompt: "What patterns of thinking do you want to change?",
    duaPrompt: "What protection are you asking Allah for?"
  },
  {
    day: 14,
    moodQuestion: "How are you maintaining your momentum?",
    gratitudePrompt: "What act of kindness touched your heart today?",
    reflectionPrompt: "How are you different from the start of Ramadan?",
    duaPrompt: "What success do you want Allah to grant you?"
  },
  {
    day: 15,
    moodQuestion: "How do you feel at the halfway point?",
    gratitudePrompt: "What has this Ramadan given you so far?",
    reflectionPrompt: "What do you want to accomplish in the remaining days?",
    duaPrompt: "What transformation do you want from Allah?"
  },
  {
    day: 16,
    moodQuestion: "What emotions are you experiencing today?",
    gratitudePrompt: "What simple pleasure are you grateful for?",
    reflectionPrompt: "How can you increase your good deeds?",
    duaPrompt: "What companionship do you seek from Allah?"
  },
  {
    day: 17,
    moodQuestion: "How is your connection with the Quran?",
    gratitudePrompt: "What wisdom has Allah granted you recently?",
    reflectionPrompt: "What ayah spoke to your situation this week?",
    duaPrompt: "What understanding do you seek from Allah?"
  },
  {
    day: 18,
    moodQuestion: "How is your patience holding up?",
    gratitudePrompt: "What difficulty has Allah turned into ease?",
    reflectionPrompt: "How are you preparing for the last ten nights?",
    duaPrompt: "What patience do you need from Allah?"
  },
  {
    day: 19,
    moodQuestion: "What is stirring in your heart?",
    gratitudePrompt: "What relationship are you grateful for?",
    reflectionPrompt: "What sincere tawbah do you want to make?",
    duaPrompt: "What purity of heart are you seeking?"
  },
  {
    day: 20,
    moodQuestion: "How do you feel completing the days of forgiveness?",
    gratitudePrompt: "What forgiveness have you experienced this period?",
    reflectionPrompt: "How has seeking forgiveness changed you?",
    duaPrompt: "What complete forgiveness do you seek from Allah?"
  },
  {
    day: 21,
    moodQuestion: "How are you feeling as the final nights begin?",
    gratitudePrompt: "What about this Ramadan are you most grateful for?",
    reflectionPrompt: "How will you maximize these blessed nights?",
    duaPrompt: "What freedom from hellfire do you seek?"
  },
  {
    day: 22,
    moodQuestion: "What is your spiritual state tonight?",
    gratitudePrompt: "What answered dua have you witnessed?",
    reflectionPrompt: "How can you increase your night prayers?",
    duaPrompt: "What eternal blessing do you want from Allah?"
  },
  {
    day: 23,
    moodQuestion: "How is your heart on this odd night?",
    gratitudePrompt: "What peace has Allah placed in your heart?",
    reflectionPrompt: "If this is Laylatul Qadr, what do you want to say to Allah?",
    duaPrompt: "What life-changing dua are you making tonight?"
  },
  {
    day: 24,
    moodQuestion: "How do you feel after last night's worship?",
    gratitudePrompt: "What energy has Allah blessed you with?",
    reflectionPrompt: "What sincerity do you want in your worship?",
    duaPrompt: "What closeness to Allah do you seek?"
  },
  {
    day: 25,
    moodQuestion: "What is your heart yearning for tonight?",
    gratitudePrompt: "What sign of Allah's love have you felt?",
    reflectionPrompt: "How can you make this night count?",
    duaPrompt: "What do you want Allah to write for you?"
  },
  {
    day: 26,
    moodQuestion: "How are you preserving your energy for worship?",
    gratitudePrompt: "What has worship given you this Ramadan?",
    reflectionPrompt: "What are you learning about consistency?",
    duaPrompt: "What steadfastness do you want from Allah?"
  },
  {
    day: 27,
    moodQuestion: "How does your heart feel on this special night?",
    gratitudePrompt: "What has Ramadan taught you about yourself?",
    reflectionPrompt: "What would you tell Allah if He accepted all your duas tonight?",
    duaPrompt: "Pour out your deepest dua - what does your soul need?"
  },
  {
    day: 28,
    moodQuestion: "How are you feeling as Ramadan winds down?",
    gratitudePrompt: "What transformation are you grateful for?",
    reflectionPrompt: "What will you miss most about Ramadan?",
    duaPrompt: "What do you want Allah to preserve for you?"
  },
  {
    day: 29,
    moodQuestion: "What emotions are you experiencing as Ramadan ends?",
    gratitudePrompt: "What has this Ramadan given your heart?",
    reflectionPrompt: "What habit from Ramadan will you maintain?",
    duaPrompt: "What continuation of blessings do you seek?"
  },
  {
    day: 30,
    moodQuestion: "How do you feel on this final day?",
    gratitudePrompt: "Summarize the greatest blessing of this Ramadan.",
    reflectionPrompt: "What message would you write to yourself for next Ramadan?",
    duaPrompt: "What is your final dua as this blessed month closes?"
  }
];

export const getPromptsForDay = (day: number): JournalPrompts => {
  const safeDay = Math.max(1, Math.min(day, 30));
  return journalPrompts[safeDay - 1];
};

export const moodOptions = [
  { value: 'grateful', label: 'Grateful', emoji: '🤲' },
  { value: 'peaceful', label: 'Peaceful', emoji: '☮️' },
  { value: 'hopeful', label: 'Hopeful', emoji: '✨' },
  { value: 'reflective', label: 'Reflective', emoji: '💭' },
  { value: 'joyful', label: 'Joyful', emoji: '🌟' },
  { value: 'content', label: 'Content', emoji: '😊' },
  { value: 'struggling', label: 'Struggling', emoji: '🌧️' },
  { value: 'anxious', label: 'Anxious', emoji: '😰' },
  { value: 'tired', label: 'Tired', emoji: '😴' },
  { value: 'motivated', label: 'Motivated', emoji: '💪' },
];
